// extracted by mini-css-extract-plugin
module.exports = {"dots":"_base-dots_dots_3Trsu","dotsUnpadded":"_base-dots_dotsUnpadded_2g8R3"};